import * as React from 'react';
import { UserMenu } from '@brightlayer-ui/react-components';
import { Avatar } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Settings, ExitToApp, Security } from '@mui/icons-material';
import PhoneIcon from '@mui/icons-material/Phone';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { useDispatch, useSelector } from 'react-redux';
import { useAuthHelper, useAuthState, getUserId } from '../AuthContextProvider';
import { useHistory } from 'react-router-dom';
import { pushAppRoute } from '../../data/domain/route-manager';
import { Thunks } from '../../actions';
import { Selectors } from '../../selectors';
import { CONTACT_EMAIL, CONTACT_PHONENO } from '../../constants';
import * as PXBColors from '@brightlayer-ui/colors';
import { isRecordFound, useUserRoles } from '../../hooks/data-hooks';

const useStyles = makeStyles(() => ({
    avatarColor: {
        color: PXBColors.white[500],
        backgroundColor: PXBColors.blue[500],
    },
    floatR: {
        float: 'right',
    },
}));
export const UserMenuToolbar: React.FC = () => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const authHelper = useAuthHelper();
    const history = useHistory();
    const authState = useAuthState();
    const userId = getUserId(authState);

    const email = useSelector(Selectors.User.email);
    const name = useSelector(Selectors.User.name);
    const initials = useSelector(Selectors.User.initials);
    const userRole = useUserRoles();
    
    const hasNoOperation = isRecordFound(userRole) ? userRole.value.every((x) => x.operations.length === 0)
        : false;
    const logoutSession = React.useCallback(() => {
        dispatch(Thunks.Authentication.logout(userId, history, authHelper.onUserNotAuthenticated));
    }, [dispatch, history, userId, authHelper.onUserNotAuthenticated]);

    return (
        <div data-testid="user-menu" className={classes.floatR}>
            <UserMenu
                MenuProps={{
                    anchorOrigin: { horizontal: 'left', vertical: 'top' },
                    transformOrigin: { horizontal: 'right', vertical: 'top' },
                }}
                avatar={<Avatar className={classes.avatarColor}>{initials}</Avatar>}
                menuTitle={name}
                menuSubtitle={email}
                menuGroups={[
                    {
                        items: [
                            {
                                itemID: 'Log Out',
                                title: 'Log Out',
                                icon: <ExitToApp />,
                                onClick: (): void => {
                                    logoutSession();
                                },
                            },
                            {
                                itemID: 'Account Settings',
                                title: 'Account Settings',
                                icon: <Settings />,
                                onClick: (): void => {
                                    if (hasNoOperation)
                                        pushAppRoute(history, { type: 'Settings' });
                                    else
                                        pushAppRoute(history, { type: 'MyProfile' });
                                },
                            },
                            {
                                itemID: 'Privacy Policy',
                                title: 'Privacy Policy',
                                icon: <Security />,
                                onClick: (): void => {
                                     window.open("https://www.eaton.com/us/en-us/company/policies-and-statements/privacy-cookies-and-data-protection.html", "_blank")
                                    },
                                divider: true,
                            },
                        ],
                    },
                    {
                        title: 'Contact Us',

                        items: [
                            {
                                itemID: 'ContactEmail',
                                title: CONTACT_EMAIL,
                                icon: <MailOutlineIcon />,
                                onClick: (): string => (window.location.href = `mailto:${CONTACT_EMAIL}`),
                            },
                            {
                                itemID: 'ContactPhoneNo',
                                title: CONTACT_PHONENO,
                                icon: <PhoneIcon />,
                                onClick: (): string => (window.location.href = `tel:${CONTACT_PHONENO}`),
                            },
                        ],
                    },
                ]}
            />
        </div>
    );
};
